// Utilities
import React from "react";
import { useEffect, useState } from "react";
import { Image as FluentImage, useTheme } from "@fluentui/react";
// Telemetry
import { useLoggers } from "@ms/uno-controls/lib/local/hooks/useLoggers";
import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/**
 * Renders the lazy image
 */ export function LazyImage({ fetchImage, placeholderSrc, ...rest }) {
    const [src, setSrc] = useState(placeholderSrc);
    const theme = useTheme();
    const { traceLogger } = useLoggers();
    useEffect(()=>{
        const imageSource = async ()=>{
            try {
                const src = await retry(()=>fetchImage(theme, traceLogger));
                if (src !== null) {
                    setSrc(src);
                } else {
                    setSrc(placeholderSrc);
                }
            } catch  {
                traceLogger.logTrace(0x1e3dd050 /* tag_4p3bq */ , TraceLevel.Error, "LazyImage - error loading image");
                setSrc(placeholderSrc);
            }
        };
        imageSource();
    }, [
        fetchImage,
        placeholderSrc,
        theme,
        traceLogger
    ]);
    return /*#__PURE__*/ React.createElement(FluentImage, {
        ...rest,
        src: src
    });
}
